import { API_BASE_URL } from '../config'

/**
 * Serviço para gerenciar pagamentos via Asaas
 */

/**
 * Cria um pagamento para impulsionar um imóvel
 * @param {number} propertyId - ID do imóvel
 * @param {number} planId - ID do plano de impulsionamento
 * @param {string} paymentMethod - Método de pagamento: 'pix', 'boleto' ou 'credit_card'
 * @param {string} token - Token JWT de autenticação
 * @returns {Promise<Object>} Dados do pagamento criado com QR Code (se PIX)
 */
export const createPayment = async (propertyId, planId, paymentMethod, token) => {
  try {
    console.log('Token recebido:', token ? 'Token presente' : 'Token ausente')
    console.log('Criando pagamento:', { propertyId, planId, paymentMethod })

    const response = await fetch(`${API_BASE_URL}/api/payments/create/`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        property_id: propertyId,
        plan_id: planId,
        payment_method: paymentMethod
      })
    })

    const data = await response.json()
    console.log('Resposta da API:', data)

    if (!response.ok) {
      throw new Error(data.error || data.detail || 'Erro ao criar pagamento')
    }

    return data
  } catch (error) {
    console.error('Erro ao criar pagamento:', error)
    throw error
  }
}

/**
 * Consulta o status de um pagamento
 * @param {number} paymentId - ID do pagamento
 * @param {string} token - Token JWT de autenticação
 * @returns {Promise<Object>} Status atualizado do pagamento
 */
export const getPaymentStatus = async (paymentId, token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/payments/${paymentId}/status/`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data.error || 'Erro ao consultar status do pagamento')
    }

    return data
  } catch (error) {
    console.error('Erro ao consultar status:', error)
    throw error
  }
}

/**
 * Lista todos os pagamentos do usuário autenticado
 * @param {string} token - Token JWT de autenticação
 * @returns {Promise<Array>} Lista de pagamentos
 */
export const getUserPayments = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/payments/my-payments/`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data.error || 'Erro ao listar pagamentos')
    }

    return data
  } catch (error) {
    console.error('Erro ao listar pagamentos:', error)
    throw error
  }
}

/**
 * Lista os planos de impulsionamento disponíveis
 * @returns {Promise<Array>} Lista de planos
 */
export const getBoostPlans = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/boost/plans/`)
    const data = await response.json()

    if (!response.ok) {
      throw new Error('Erro ao carregar planos')
    }

    // Normaliza a resposta - pode vir como array direto ou como objeto paginado
    if (Array.isArray(data)) {
      return data
    } else if (data.results && Array.isArray(data.results)) {
      return data.results
    } else {
      return []
    }
  } catch (error) {
    console.error('Erro ao carregar planos:', error)
    throw error
  }
}

/**
 * Regenera o QR Code PIX de um pagamento
 * @param {number} paymentId - ID do pagamento
 * @param {string} token - Token JWT de autenticação
 * @returns {Promise<Object>} Pagamento com novo QR Code
 */
export const refreshPixQrCode = async (paymentId, token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/payments/${paymentId}/refresh-pix/`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data.error || 'Erro ao regenerar QR Code')
    }

    return data
  } catch (error) {
    console.error('Erro ao regenerar QR Code PIX:', error)
    throw error
  }
}
